import '../../sass/pages/_home.scss'

// Import API
import { apiService } from '../services/api'
const api = new apiService();

// Import Swiper
import Swiper, { Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// Import GSAP
declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger)

// Import components
import SplitText from "../components/SplitText"
declare global {
    interface Window {
        dataLayer: any
    }
}

window.addEventListener('DOMContentLoaded', function () {
    ScrollTrigger.refresh()
})

const Home = () => {
    // sliderHome()
    indicators()
    activities()
	swipers()
    headerBanner()
    modalToggle()
    setSplitText()

    setTimeout(() => {
        modalAuthenticated()
    }, 1000);
}

(function page() {
	Home()
})()

function sliderHome() {
    const containerHomer = document.querySelector('.mvm-home__banner .swiper-wrapper');
    const url = '/get/slider'
    fetch(url)
        .then(respuestas => respuestas.json())
        .then(respuesta => {
            respuesta.map( (e:any) => {
                const newSlide = document.createElement('div');
                newSlide.setAttribute('style', 'background: linear-gradient(45deg, #00205C 10%, #FF501E 90%);');
                newSlide.classList.add('swiper-slide', 'page');

                const bannerInfo = document.createElement('div');
                bannerInfo.classList.add('mvm-home__banner-info');

                const bannerTitle = document.createElement('div');
                bannerTitle.classList.add('mvm-home__banner-title');
                const h2 = document.createElement('h2');
                h2.classList.add('title');
                h2.textContent = e.titulo;
                bannerTitle.appendChild(h2);

                const bannerText = document.createElement('div');
                bannerText.classList.add('mvm-home__banner-text', 'medium_22');
                bannerText.textContent = e.descripcion;

                const anchor = document.createElement('a');
                anchor.href = `/${e.url.uri}`;
                anchor.classList.add('btn--solidWhite');
                anchor.textContent = e.url.title;
                anchor.setAttribute('onclick', 'buttonBanner()');

                const picture = document.createElement('picture');
                picture.classList.add('mvm-home__banner-image');
                const img = document.createElement('img');
                img.src = e.imagen;
                img.alt = 'voluntarios grupo modelo';
                img.title = 'voluntarios grupo modelo';
                picture.appendChild(img);

                bannerInfo.appendChild(bannerTitle);
                bannerInfo.appendChild(bannerText);
                bannerInfo.appendChild(anchor);

                newSlide.appendChild(bannerInfo);
                newSlide.appendChild(picture);

                document.querySelector('.swiper-wrapper')?.appendChild(newSlide);

                containerHomer?.appendChild(newSlide)
            })
        })
}

function modalAuthenticated() {
    const modal = document.querySelector('#modal--autenticado') as HTMLElement
    const close = modal?.querySelector('.mvm-modal-close') as HTMLElement
    const button = modal?.querySelector('.btn--solidRed') as HTMLElement

    if (modal) {
        if(!modal.classList.contains('is-close')) {
            document.querySelector('body')?.classList.add('noScroll')
        }

        close?.addEventListener('click', function () {
            modal.classList.add('is-close')
            document.querySelector('body')?.classList.remove('noScroll')
        })

        button?.addEventListener('click', function () {
            modal.classList.add('is-close')
            document.querySelector('body')?.classList.remove('noScroll')
        })
    }
}

function setSplitText() {
    setTimeout(() => {
        new SplitText('.mvm-home__banner-title .title')
        new SplitText('.mvm-home__banner-text p')
        new SplitText('.mvm-home__activities-title .subtitle')
    }, 1000);
    new SplitText('.mvm-home__indicators-content .subtitle')
    new SplitText('.mvm-home__talks-title')
    new SplitText('.mvm-home__talks-desc .medium_22')
    new SplitText('.mvm-home__blog h2.subtitle')
}

function swipers() {
    const swiperWeeks = new Swiper('.swiperBanner', {
        modules: [ Navigation ],
        spaceBetween: 0,
        speed: 1000,
        direction: 'horizontal',
        // loop: false,
        // slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })
}

function headerBanner() {
    const banner = document.querySelector('.mvm-home__banner') as HTMLElement

    banner.addEventListener('click', function (e: any) {
        let target = e.target
        if(target.dataset.text && target.classList.contains('header-item')) {
            let parent = target.closest('.mvm-home__banner-header')
            let itemActive = parent.querySelector('.header-item.black_22')
            itemActive?.classList.remove('black_22')
            itemActive?.classList.add('medium_22')

            target.classList.remove('medium_22')
            target.classList.add('black_22')

            let parentInfo = target.closest('.mvm-home__banner-info')
            let paragActive = parentInfo.querySelector('p.active')
            paragActive?.classList.remove('active')

            parentInfo.querySelector(`p[data-text=${target.dataset.text}]`)?.classList.add('active')
        }
    })
}

function modalToggle() {
    const openModalButton = document.querySelector('.modal-open') as HTMLElement;
    const title = document.querySelector('.mvm-home__talks-title')?.innerHTML
    window.dataLayer = window.dataLayer || [];
    if (openModalButton) {
        const videoId = openModalButton.querySelector('iframe')?.dataset.src
        const idModal = openModalButton.getAttribute('data-modal')
        const modal = document.querySelector(`.mvm-modal[data-modal="${idModal}"]`)
        if (modal) {
            const close = modal.querySelector('.mvm-modal-close');
            const videos = modal.querySelectorAll('iframe');

            openModalButton.addEventListener('click', function () {
                if(videos) {
                    videos.forEach((video) => {
                        // https://www.youtube.com/embed/
                        video.src = `https://www.youtube.com/embed/${videoId}`
                    })
                }

                if (modal) {
                    modal.classList.remove('is-close');
                    document.querySelector('body')?.classList.add('noScroll')
                }
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Video',
                    'event_action': 'play',
                    'event_label': `${title}`,
                    'interaction':'true',
                });
            })

            if (modal && close) {
                close.addEventListener("click", function () {
                    modal.classList.add("is-close");
                    document.querySelector('body')?.classList.remove('noScroll')

                    if (videos) {
                        videos.forEach((video) => {
                            video.src = ''
                        })
                    }
                })
            }
        }

    }
}

async function getActivities(){
    return new Promise(async (resolve: any) => {
        const request = await api.activities()
        resolve(request)
    })
}

function activities () {
    const contentActivities = document.querySelector('.mvm-home__activities-dest') as HTMLElement
    const boxActivities = document.querySelector('.mvm-home__activities') as HTMLElement

    contentActivities.innerHTML = ''
    getActivities().then(function (data: any) {
        console.log("activities", data)
        if (data.length >= 1) {
            boxActivities.classList.remove('hidden')
            data.forEach((element: any, index: any) => {
                const activityLink = document.createElement('a');
                activityLink.href = data[index].url_activity;
                activityLink.classList.add('mvm__activity');

                const img = document.createElement('img');
                img.classList.add('mvm__activity-image', 'lazyload');
                img.setAttribute('data-src', data[index].url_image);
                img.alt = '';
                activityLink.appendChild(img);

                const title = document.createElement('h2');
                title.classList.add('subtitleSmall');
                title.textContent = data[index].title;
                activityLink.appendChild(title);

                const info = document.createElement('div');
                info.classList.add('mvm__activity-info');

                const category = document.createElement('p');
                category.classList.add('black_22');
                category.textContent = data[index].category;

                const city = document.createElement('p');
                city.classList.add('medium_22');
                city.textContent = data[index].city;

                info.appendChild(category);
                info.appendChild(city);
                activityLink.appendChild(info);

                const dates = document.createElement('div');
                dates.classList.add('mvm__activity-dates');

                const startDate = document.createElement('div');
                startDate.classList.add('mvm__activity-start');

                const startLabel = document.createElement('div');
                startLabel.classList.add('medium_18');
                startLabel.textContent = 'Fecha de inicio';

                const startDateText = document.createElement('div');
                startDateText.classList.add('date', 'black_22');
                startDateText.textContent = data[index].start_date;

                const startTimeText = document.createElement('div');
                startTimeText.classList.add('hour', 'black_22');
                startTimeText.textContent = data[index].start_time;

                startDate.appendChild(startLabel);
                startDate.appendChild(startDateText);
                startDate.appendChild(startTimeText);

                dates.appendChild(startDate);

                if (data[index].end_date !== '' && data[index].end_time !== '') {
                    const endDate = document.createElement('div');
                    endDate.classList.add('mvm__activity-end');

                    const endLabel = document.createElement('div');
                    endLabel.classList.add('medium_18');
                    endLabel.textContent = 'Fecha de finalización';

                    const endDateText = document.createElement('div');
                    endDateText.classList.add('date', 'black_22');
                    endDateText.textContent = data[index].end_date;

                    const endTimeText = document.createElement('div');
                    endTimeText.classList.add('hour', 'black_22');
                    endTimeText.textContent = data[index].end_time;

                    endDate.appendChild(endLabel);
                    endDate.appendChild(endDateText);
                    endDate.appendChild(endTimeText);

                    dates.appendChild(endDate);
                }

                activityLink.appendChild(dates);

                const button = document.createElement('div');
                button.classList.add('btn--transparent');
                button.textContent = 'Ver Más';
                activityLink.appendChild(button);

                contentActivities.appendChild(activityLink);
            });
        }
    });

    contentActivities.addEventListener('click', function (e: any) {
        let target = e.target
        let title : any;
        window.dataLayer = window.dataLayer || [];
        if(target.classList.contains('mvm__activity') || target.classList.contains('btn--transparent')) {
            if(target.classList.contains('mvm__activity')){
                title = target.querySelector('.subtitleSmall')
            }else if(target.classList.contains('btn--transparent')){
                title = target.parentNode.querySelector('.subtitleSmall')
            }
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Home- actividades',
                'event_action': 'button',
                'event_label': `${title.innerHTML}`,
                'interaction':'true',
                'component_name': 'button_Ver más',
                'element_text': 'Ver más'
            });
        }
    })
}

async function getIndicators(){
    return new Promise(async (resolve: any) => {
        const request = await api.indicators()
        resolve(request)
    })
}

function indicators() {
    const voluntariosRegistrados = document.querySelector('#voluntariosRegistrados') as HTMLElement
    const iniciativas = document.querySelector('#iniciativas') as HTMLElement
    const beneficiarios = document.querySelector('#beneficiarios') as HTMLElement
    const horasVoluntarias = document.querySelector('#horasVoluntarias') as HTMLElement

    getIndicators().then(function (data: any) {
        voluntariosRegistrados.innerHTML = data.voluntarios;
        iniciativas.innerHTML = data.actividades;
        beneficiarios.innerHTML = data.beneficiarios;
        horasVoluntarias.innerHTML = data.horas;
    });
}
